import React from 'react';
const testimonials = [{
  initials: 'MG',
  quote: 'Organicé todo el año en una tarde. Nunca más llegué sin material al club.',
  name: 'Marcos G.',
  location: 'Córdoba'
}, {
  initials: 'LP',
  quote: 'Las sesiones están pensadas para el pibe argentino de club de barrio. Vale cada peso.',
  name: 'Laura P.',
  location: 'Rosario'
}, {
  initials: 'RM',
  quote: 'El Manual del DT Ganador fue el plus que me faltaba para ganar desde el banco.',
  name: 'Roberto M.',
  location: 'Buenos Aires'
}];
export function SocialProofBar() {
  return <section className="w-full bg-[#001a0d] py-8 sm:py-10 px-4" data-id="element-188">
      <div className="max-w-4xl mx-auto" data-id="element-189">
        {/* Compact stats bar */}
        <div className="flex items-center justify-center gap-4 sm:gap-8 mb-6 sm:mb-8 flex-wrap" data-id="element-190">
          <div className="flex items-center gap-1.5" data-id="element-191">
            <span className="text-white font-black text-xl sm:text-2xl" data-id="element-192">
              +500
            </span>
            <span className="text-[#00C853] text-xs sm:text-sm font-semibold" data-id="element-193">
              profes
            </span>
          </div>
          <div className="w-px h-5 bg-[#00C853]/30 hidden sm:block" data-id="element-194" />
          <div className="flex items-center gap-1.5" data-id="element-195">
            <span className="text-white font-black text-xl sm:text-2xl" data-id="element-196">
              4.9/5
            </span>
            <span className="text-[#00C853] text-xs sm:text-sm font-semibold" data-id="element-197">
              ⭐
            </span>
          </div>
          <div className="w-px h-5 bg-[#00C853]/30 hidden sm:block" data-id="element-198" />
          <div className="flex items-center gap-1.5" data-id="element-199">
            <span className="text-white font-black text-xl sm:text-2xl" data-id="element-200">
              6+6
            </span>
            <span className="text-[#00C853] text-xs sm:text-sm font-semibold" data-id="element-201">
              tomos + bonos
            </span>
          </div>
          <div className="w-px h-5 bg-[#00C853]/30 hidden sm:block" data-id="element-202" />
          <div className="flex items-center gap-1.5" data-id="element-203">
            <span className="text-white font-black text-xl sm:text-2xl" data-id="element-204">
              🇦🇷
            </span>
            <span className="text-[#00C853] text-xs sm:text-sm font-semibold" data-id="element-205">
              todo el país
            </span>
          </div>
        </div>

        {/* Compact testimonials */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3" data-id="element-206">
          {testimonials.map((t, i) => <div key={i} className="flex items-start gap-3 bg-black/30 border border-[#00C853]/15 rounded-xl p-3 sm:p-4" data-id="element-207">
              <div className="w-8 h-8 rounded-full bg-[#00C853]/15 flex items-center justify-center text-[#00C853] font-bold text-xs flex-shrink-0" data-id="element-208">
                {t.initials}
              </div>
              <div className="min-w-0" data-id="element-209">
                <p className="text-white text-sm font-medium leading-snug" data-id="element-210">
                  "{t.quote}"
                </p>
                <p className="text-gray-400 text-xs mt-1" data-id="element-211">
                  — {t.name}, {t.location}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}